const theme = {
  'primaryColor': '#EDEDED',
  'globalHeader': {
    'headerIcon': 'arrowGrey',
  }
}

export { theme }